import { MutableRefObject } from 'react';
import { useUnit } from 'effector-react';
import { CircularProgress, ClickAwayListener, Divider, Paper } from '@mui/material';
import {
  $isLoading,
  $isPopperVisible,
  ContactCallsGate,
  setPopperVisiblity,
} from '../../model/main';
import { CallsList } from '../calls-list';
import { PopperHeader } from './header';
import { ResetEndedCalls } from './reset-ended-calls';
import * as Styled from './styled';

export const ContactCallsPopper = ({
  badgeRef,
}: {
  badgeRef: MutableRefObject<HTMLButtonElement | null>;
}) => {
  const [isPopperVisible, isLoading] = useUnit([$isPopperVisible, $isLoading]);

  const closeByClickAway = (event: MouseEvent | TouchEvent) => {
    if (badgeRef.current && badgeRef.current.contains(event.target as Node)) return;
    if (isPopperVisible !== 'all') return;

    setPopperVisiblity(false);
  };

  return (
    <ClickAwayListener onClickAway={closeByClickAway}>
      <Styled.Popper
        id={'contact-calls'}
        open={!!isPopperVisible}
        anchorEl={badgeRef.current}
        placement="bottom-end"
      >
        <ContactCallsGate />

        <Paper elevation={8}>
          <PopperHeader />

          <Divider />

          <Styled.BackdropWrapper>
            <Styled.Backdrop open={isLoading}>
              <CircularProgress size={16} />
            </Styled.Backdrop>

            <CallsList />

            <ResetEndedCalls />
          </Styled.BackdropWrapper>
        </Paper>
      </Styled.Popper>
    </ClickAwayListener>
  );
};
